export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VuesticPopover.vue?vue&type=template&id=02321376&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-popover/VuesticPopover.vue?vue&type=template&id=02321376&scoped=true
// module id = nMEo
// module chunks = 41